import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_AUTH_ENROLL_TOTP_FACTOR_URL } from "constants/apiUrls";

import { AuthTransaction } from "../types/authTransaction";
import { Provider } from "types/factor/factor";
import { OktaError } from "types/oktaError/oktaError";

import useAuthTransactionApiClient from "./useAuthTransactionApiClient";

export type EnrollTotpData = {
  stateToken: string;
  provider: Provider;
};

function useAuthEnrollTotp(): UseMutationResult<
  AuthTransaction,
  OktaError,
  EnrollTotpData
> {
  const authTransactionApiClient = useAuthTransactionApiClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await authTransactionApiClient(
        API_AUTH_ENROLL_TOTP_FACTOR_URL,
        {
          method: "POST",
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await response.json();
      }
    },
  });
}

export default useAuthEnrollTotp;
